var _path, _path2, _path3, _path4, _path5, _circle, _path6, _circle2, _path7, _circle3, _path8, _circle4, _path9, _circle5, _path10, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataZoneButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32727 2H2V6.32727",
    stroke: "#888888",
    strokeWidth: 2.31818,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2093 19L18.5366 19L18.5366 14.6727",
    stroke: "#888888",
    strokeWidth: 2.31818,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.6727L2 19L6.32727 19",
    stroke: "#888888",
    strokeWidth: 2.31818,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5366 6.32727L18.5366 2L14.2093 2",
    stroke: "#888888",
    strokeWidth: 2.31818,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8264 7.12487C14.8264 8.24825 12.7648 11.1612 12.7648 11.1612C12.7648 11.1612 10.7031 8.24825 10.7031 7.12487C10.7031 6.0015 11.6262 5.09082 12.7648 5.09082C13.9034 5.09082 14.8264 6.0015 14.8264 7.12487Z",
    fill: "#888888"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8209,
    cy: 7.09534,
    r: 0.859015,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8269 7.12487C14.8269 8.24825 12.7652 11.1612 12.7652 11.1612C12.7652 11.1612 10.7036 8.24825 10.7036 7.12487C10.7036 6.0015 11.6266 5.09082 12.7652 5.09082C13.9039 5.09082 14.8269 6.0015 14.8269 7.12487Z",
    fill: "#888888"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8219,
    cy: 7.09534,
    r: 0.859015,
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8274 7.12487C14.8274 8.24825 12.7657 11.1612 12.7657 11.1612C12.7657 11.1612 10.7041 8.24825 10.7041 7.12487C10.7041 6.0015 11.6271 5.09082 12.7657 5.09082C13.9043 5.09082 14.8274 6.0015 14.8274 7.12487Z",
    fill: "#888888"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8224,
    cy: 7.09534,
    r: 0.859015,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8279 7.12487C14.8279 8.24825 12.7662 11.1612 12.7662 11.1612C12.7662 11.1612 10.7046 8.24825 10.7046 7.12487C10.7046 6.0015 11.6276 5.09082 12.7662 5.09082C13.9048 5.09082 14.8279 6.0015 14.8279 7.12487Z",
    fill: "#888888"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8229,
    cy: 7.09534,
    r: 0.859015,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8288 7.12487C14.8288 8.24825 12.7672 11.1612 12.7672 11.1612C12.7672 11.1612 10.7056 8.24825 10.7056 7.12487C10.7056 6.0015 11.6286 5.09082 12.7672 5.09082C13.9058 5.09082 14.8288 6.0015 14.8288 7.12487Z",
    fill: "#888888"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8234,
    cy: 7.09534,
    r: 0.859015,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.145 12.417C9.145 13.4918 7.17235 16.2791 7.17235 16.2791C7.17235 16.2791 5.19971 13.4918 5.19971 12.417C5.19971 11.3421 6.08289 10.4707 7.17235 10.4707C8.26182 10.4707 9.145 11.3421 9.145 12.417Z",
    fill: "#888888"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.22672,
    cy: 12.3883,
    r: 0.821936,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataZoneButton);
export default __webpack_public_path__ + "static/media/dataZoneButton.d8ced5390fdbeca6b50acdeb2fe6f8cc.svg";
export { ForwardRef as ReactComponent };